module.exports = __webpack_public_path__ + "static/media/3.ef666422.JPG";